import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {ReactComponent as CloseIcon} from "assets/img/wms/close_medium.svg";
import {black500, greyishBlue100} from "assets/jss/main";

BottomDrawerHead.propTypes = {
    onClose: PropTypes.func
};

function BottomDrawerHead({onClose = () => {}, ...props }) {
    return (
        <div
            style={{
                background: '#fff',
                width: '100%',
                position: 'sticky',
                top: 0,
                padding: '16px',
                borderBottom: `1px solid ${greyishBlue100}`,
                zIndex: 1
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 18,
                    left: 20,
                }}
            >
                <CloseIcon onClick={() => onClose()} />
            </div>
            <div
                style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: black500,
                    textAlign: 'center'
                }}
            >
                {props.children}
            </div>
        </div>
    );
}

export default BottomDrawerHead;
